import React from 'react';
import IconButton from '@mui/material/IconButton';
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded';

interface ContextMenuButtonProps {
  readonly row: unknown;
  readonly onOpenMenu: (
    e: React.MouseEvent<HTMLButtonElement>,
    row: unknown
  ) => void;
  readonly onCloseMenu?: () => void;
  readonly anchorEl?: HTMLElement | null;
}

export function ContextMenuButton({ row, onOpenMenu }: ContextMenuButtonProps) {
  return (
    <IconButton
      size="small"
      onClick={(e) => {
        e.stopPropagation();
        onOpenMenu(e, row);
      }}
      sx={{
        color: 'text.secondary',
        borderRadius: '8px',
        p: 0.75,
        transition: 'all 0.2s',
        '&:hover': {
          bgcolor: 'action.hover',
          color: 'text.primary',
        },
      }}
    >
      <MoreVertRoundedIcon sx={{ fontSize: 20 }} />
    </IconButton>
  );
}

